<div>
  <div class="px-4 py-2 bg-white">
    <h1>Supplier Risk Management</h1>
    <p class="mb-0" *ngIf="selectedView === RiskManagementView.Risks">
      List of Suppliers with work today
      <span class="bold-text">{{ currentDate | datex : 'ddd, DD MMMM YYYY' }}</span
      >.

      <span *ngIf="data != null && data.lastUpdated">
        Last updated at
        <span class="bold-text">{{ data.lastUpdated | datex : 'HH:mm' }}</span
        >.
      </span>
    </p>
    <p class="mb-0" *ngIf="selectedView === RiskManagementView.UnscheduledTasks">
      Allocated tasks without a driver schedule, ordered by latest pickup date. Only tasks with a
      driver schedule will appear in the risk management page.
    </p>
    <p class="mb-0" *ngIf="selectedView === RiskManagementView.AssignmentHistory">
      See who was assigned to each supplier, when it happened, and who made the change, with the
      most recent changes first.
      <span class="bold-text">Assignment history is only kept for 30 days.</span>
    </p>
  </div>

  <div class="border-1 border-gray-100 px-4 py-2 bg-white">
    <risk-management-view-tabs
      [selectedView]="selectedView"
      [unscheduledCount]="unscheduledCount"
      [loadingCount]="loadingUnscheduledCount"
      [isRiskManagementAdmin]="isUserRiskManagementAdmin"
      (viewChanged)="handleViewChanged($event)"
    ></risk-management-view-tabs>
  </div>

  <unscheduled-tasks
    *ngIf="selectedView === RiskManagementView.UnscheduledTasks"
    (taskScheduled)="handleTaskScheduled()"
  ></unscheduled-tasks>

  <assignment-history
    *ngIf="selectedView === RiskManagementView.AssignmentHistory && isUserRiskManagementAdmin"
  ></assignment-history>

  <ng-container *ngIf="selectedView === RiskManagementView.Risks">
    <div
      class="border-1 border-gray-100 px-4 py-2 bg-white flex gap-2 align-items-center justify-content-between"
    >
      <risk-management-tabs
        (tabChanged)="handleTabChanged($event)"
        [selectedTab]="selectedTab"
        [counts]="tabCounts"
        [loading]="loadingCounts"
      ></risk-management-tabs>
      <div>
        <button
          pButton
          type="button"
          label="Unassign All"
          class="ui-button-secondary"
          (click)="unassignAll()"
          *ngIf="isUserRiskManagementAdmin"
        ></button>
        <button
          pButton
          type="button"
          label="Unassign Me"
          class="ui-button-secondary"
          (click)="unassignMe()"
        ></button>
      </div>
    </div>
    <div class="bg-white px-4 py-2">
      <risk-management-filters (searchClicked)="loadData($event)"></risk-management-filters>
    </div>

    <div *ngIf="isLoading" class="flex w-full justify-content-center my-4 bg-gray-100">
      <i class="fa fa-spin fa-spinner fa-3x"></i>
    </div>

    <div class="p-4 flex justify-content-center" *ngIf="!isLoading && data.total == 0">
      <h4>No suppliers found matching the criteria. Change the filters and try again.</h4>
    </div>

    <div class="grid grid-gap-15 px-4 py-2" *ngIf="!isLoading && data.total > 0">
      <div class="col">
        <p-panel header="Suppliers ({{ data.total }})" styleClass="no-padding-panel">
          <risk-management-supplier-list-item
            (selectedSupplierChange)="selectSupplier($event)"
            *ngFor="let supplier of paginatedRiskDetail; trackBy: trackBySupplierId"
            [riskManagementSupplier]="supplier"
            (reviewStatusChange)="handleReviewStatusChange($event)"
          ></risk-management-supplier-list-item>

          <p-footer>
            <div class="flex">
              <div class="flex-grow-1">
                <p-paginator
                  [rows]="pageSize"
                  [totalRecords]="data.total"
                  [rowsPerPageOptions]="[5, 10, 50]"
                  (onPageChange)="paginate($event)"
                  [alwaysShow]="false"
                  [first]="pageSize * pageIndex"
                ></p-paginator>
              </div>
            </div>
          </p-footer>
        </p-panel>
      </div>
      <div class="col selected-supplier-col">
        <p-panel header="Selected Supplier">
          <risk-management-selected-supplier
            [riskManagementSupplier]="paginatedRiskDetail[selectedSupplierIndex]"
            (assignedUserChange)="handleAssigneeChanged($event)"
            (reviewStatusChange)="handleReviewStatusChange($event)"
          ></risk-management-selected-supplier>
        </p-panel>
      </div>
    </div>
  </ng-container>
</div>

<p-confirmDialog></p-confirmDialog>
